/* eslint-disable max-len */
import React from 'react';

function Line(props) {
    const { component } = props;
    return (
        <div 
            id={component?.type}
            className={`w-full cursor-default`}
            data-testid="line_component"
            style={{
                ...component?.styles,
                ...(component.line_type === 'Vertical' ? { width: component.styles.borderTopWidth, height: component.styles.width, borderRightWidth: component.styles.borderTopWidth, borderTopWidth:'0px'} : { height: '0px', width: component.styles.width, borderTopWidth: component.styles.borderTopWidth })
            }}
        />
    );
}

export default Line;